import React from 'react';
import { Form, UploadInput } from '@thinknet-gmbh/platform-common-ui';

import { useTranslation } from 'react-i18next';
import { PersonalIdCardWrapper } from './personal-id-card.styles';

import { UploadFile } from 'antd/es/upload/interface';

const PersonalIdCard = () => {
  const { t } = useTranslation('employee');

  return (
    <PersonalIdCardWrapper>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const personalIdCardFront = getFieldValue('personalIdCardFrontId');
          return (
            <Form.Item
              valuePropName="file"
              name="personalIdCardFrontId"
              className={'personal-id-file-field'}
              rules={[
                {
                  required: true,
                  message: t('common:validation.error.fieldRequired'),
                },
                {
                  validator: (_: any, value: {
                    file?: UploadFile
                  }) => {
                    const file = value?.file
                    return file?.status !== 'removed'
                      ? Promise.resolve()
                      : Promise.reject(new Error(t('common:validation.error.fieldRequired')));
                  },
                },
              ]}
              label={t('employee:questionnaire.employeePersonalInfo.labels.personalIdCardFront')}
            >
              <UploadInput
                showUploadList
                beforeUpload={() => false}
                variant="DashedContainer"
                btnText={t('settings:documents.buttons.uploadFile')}
                accept=".jpg, .jpeg, .png"
                maxCount={1}
                defaultFileList={
                  personalIdCardFront
                    ? [
                        {
                          uid: personalIdCardFront?.file?.key,
                          name: personalIdCardFront?.file?.name,
                          url: personalIdCardFront?.file?.location,
                        },
                      ]
                    : undefined
                }
              />
            </Form.Item>
          );
        }}
      </Form.Item>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const personalIdCardBack = getFieldValue('personalIdCardBackId');
          return (
            <Form.Item
              name="personalIdCardBackId"
              className={'personal-id-file-field'}
              valuePropName="file"
              rules={[
                {
                  required: true,
                  message: t('common:validation.error.fieldRequired'),
                },
                {
                  validator: (_: any, value: {
                    file?: UploadFile
                  }) => {
                    const file = value?.file
                    return file?.status !== 'removed'
                      ? Promise.resolve()
                      : Promise.reject(new Error(t('common:validation.error.fieldRequired')));
                  },
                },
              ]}
              label={t('employee:questionnaire.employeePersonalInfo.labels.personalIdCardBack')}
            >
              <UploadInput
                showUploadList
                beforeUpload={() => false}
                variant="DashedContainer"
                btnText={t('settings:documents.buttons.uploadFile')}
                accept=".jpg, .jpeg, .png"
                maxCount={1}
                defaultFileList={
                  personalIdCardBack
                    ? [
                        {
                          uid: personalIdCardBack?.file?.key,
                          name: personalIdCardBack?.file?.name,
                          url: personalIdCardBack?.file?.location,
                        },
                      ]
                    : undefined
                }
              />
            </Form.Item>
          );
        }}
      </Form.Item>
    </PersonalIdCardWrapper>
  );
};

export default PersonalIdCard;
